import styles from "./StatusMessages.module.css";

export interface StatusMessagesProps {
  error?: Error | null;
  isLoading?: boolean;
  errorLabel: string;
  loadingLabel: string;
  testId?: string;
}

export function StatusMessages({
  error,
  isLoading = false,
  errorLabel,
  loadingLabel,
  testId,
}: StatusMessagesProps) {
  if (error) {
    return (
      <div
        className={styles.errorState}
        data-testid={testId ? `${testId}-error` : undefined}
      >
        {errorLabel}: {error.message}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div
        className={styles.loadingState}
        data-testid={testId ? `${testId}-loading` : undefined}
      >
        {loadingLabel}
      </div>
    );
  }

  return null;
}

StatusMessages.displayName = "StatusMessages";

export default StatusMessages;
